<template>
  <v-container>
      <servi></servi>
  </v-container>
</template>

<script>
import servi from '@/components/servi'
export default {
    components: {
        servi
    }
}
</script>

<style>

</style>